/* src/app/views/area-publica/detalhes-projeto/potenciais-table-public/potenciais-table-public.component.scss */
.panel-height {
  height: auto;
  padding: 1% 0;
}
.body-content-header {
  font-size: 16px;
  font-weight: 500;
  padding: 0px 56px 0 25px;
}
.body-title {
  text-decoration: none;
  font: normal normal normal 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #2E3241;
}
.grey-bg {
  background-color: #fafafa !important;
}
.soft-grey-bg {
  background-color: #fdfdfd !important;
}
.soma {
  text-align: left;
  letter-spacing: 0px;
  color: #007AC2;
  font-weight: 600 !important;
}
.box {
  max-height: 37vh;
  width: 100%;
  overflow: auto;
}
.potencial-list {
  margin-top: 8px;
  margin-bottom: 8px;
}
.potencial-list .potencial-detail {
  margin: 1% auto;
  width: 90%;
  border: 1px solid #80BDE0;
  border-radius: 4px;
}
.potencial-list .potencial-detail .potencial-detail-header {
  font-size: 16px;
  font-weight: 500;
  background: #80BDE0 0% 0% no-repeat padding-box;
}
.potencial-list .potencial-detail .potencial-detail-header .potencial-detail-header-margin {
  margin: 0.5% 2%;
}
.potencial-list .potencial-detail .potencial-detail-body {
  font-size: 16px;
  font-weight: 500;
  color: #2E3241;
}
.potencial-list .potencial-detail .potencial-detail-body .potencial-detail-body-margin {
  margin: 0.5% 2%;
}
.data-potencial-header {
  text-align: left;
  font: normal normal normal 12px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
  color: #757575;
  text-transform: uppercase;
}
.number-value {
  text-align: left;
  font: normal normal normal 20px/26px Montserrat, sans-serif;
  letter-spacing: 0px;
}
.header-table-detalhes-potencial {
  text-align: center;
  color: #ffffff;
}
.soma-potencial-column {
  margin-right: 40px;
}
/*# sourceMappingURL=potenciais-table-public.component.css.map */
